module.exports = __webpack_public_path__ + "912ec66d7572ff821749319396470bde.svg";